import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-sidenav-cell',
    templateUrl: './sidenav-cell.component.html',
    styleUrls: ['./sidenav-cell.component.scss']
})
export class SidenavCellComponent implements OnInit, OnChanges {

    public static readonly CELL_BEHAVE_SELECTED = 'selected';
    public static readonly CELL_BEHAVE_UNSELECTED = 'un-selected';

    @Input('id') public id: string;
    @Input('text') public text: string;
    @Input('icon') public icon: string;
    @Input('isSelected') public isSelected: boolean;
    @Input('expand') public expand: any;
    @Input('ruta') public ruta: string;
    @Output('cellClick') public cellClickHandler: EventEmitter<string> = new EventEmitter();
    @Output('subcellClick') public subcellClickHandler: EventEmitter<string> = new EventEmitter();

    public status: string;
    public submenuHeight: string;
    public submenuOpen: string;
    public isOpen: boolean = true;

    constructor() {
    }

    ngOnInit() {
        this.submenuHeight = (this.expand ? (this.expand.length) * 46 : 0) + 'px';

        if (this.isSelected) {
            this.status = SidenavCellComponent.CELL_BEHAVE_SELECTED;
        } else {
            this.status = SidenavCellComponent.CELL_BEHAVE_UNSELECTED;
        }
    }

    ngOnChanges( changes: SimpleChanges) {
        if (this.isSelected) {
            this.status = SidenavCellComponent.CELL_BEHAVE_SELECTED;
            this.submenuOpen = this.submenuHeight;
        } else {
            this.status = SidenavCellComponent.CELL_BEHAVE_UNSELECTED;
            this.submenuOpen = '0px';
        }
    }

    public sidenavClicked() {
        
        
     
        const height = [];
        if (this.expand) {
            for (const e of this.expand) {
                if (!(e.visible === false)) {
                    height.push(e);
                }
            }
        }
        this.submenuHeight = (height.length > 0) ? (height.length * 48).toString() + 'px' : '0';
        
        this.cellClickHandler.emit(this.id);
        if (this.isOpen) {
            this.isOpen = false;
            this.submenuOpen = '0px';
            this.isSelected = false;
            if (this.id.localeCompare('inicio') == 0 ){
                this.subcellClickHandler.emit(this.id);
            }
        } else {
            this.isOpen = true;
            this.submenuOpen = this.submenuHeight;
            this.isSelected = true;
        }
        
       
    //    this.cellClickHandler.emit(this.id);
    //    this.isOpen = false;
    }

    public subSidenavClicked(id: string) {
        this.subcellClickHandler.emit(id);
    }

}
